import { COLORS, FONTS, SIZE } from '@app/src/ui';
import styled from 'styled-components';
import { Title } from '@app/src/common/Title';

interface Props {
  active?: boolean;
}

const ROOT = 'MyAccount/listAvailable/ListAvailable';

export const Container = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 0 15px;

  @media (min-width: 980px) {
    padding: 0;
  }
`;

Container.displayName = `${ROOT}/Container`;

export const Head = styled.div`
  background: #fff;
  //margin: 0 0 17px;

  &.fixed {
    width: 100%;
    position: fixed;
    z-index: 300;
    left: 0;
    margin: 0 auto;
  }

  ${Container} {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid ${COLORS.GRAY};
    padding: 8px 15px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 0 0 32px;

    ${Container} {
      border-bottom: 1px solid #000;
      padding: 20px 15px;
    }
  }
`;

Head.displayName = `${ROOT}/Head`;

export const TitleWrapper = styled(Title)`
  margin: 0;
`;

TitleWrapper.displayName = `${ROOT}/TitleWrapper`;

export const Content = styled.div`
  margin-top: 17px;
`;

Content.displayName = `${ROOT}/Content`;

export const Subtitle = styled.h2`
  font-weight: 400;
  text-transform: uppercase;
  font-size: 16px;
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLACK_BOLD};
`;

Subtitle.displayName = `${ROOT}/Subtitle`;

export const ListCurrentAnnouncement = styled.ul`
  padding: 0 0 12px;
`;

ListCurrentAnnouncement.displayName = `${ROOT}/ListCurrentAnnouncement`;

export const ItemCurrent = styled.li`
  padding: 0 20px 20px 20px;
  &:nth-child(3n) {
    margin-right: 0;
  }
`;

ItemCurrent.displayName = `${ROOT}/ItemCurrent`;

export const Helper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -5px;

  @media (min-width: ${SIZE.DESKTOP}) {
    justify-content: flex-start;
    margin: 0 -20px;
  }
`;

Helper.displayName = `${ROOT}/Helper`;

export const LoaderWrapper = styled.div`
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

LoaderWrapper.displayName = `${ROOT}/LoaderWrapper`;

export const NotContent = styled.div`
  min-height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

NotContent.displayName = `${ROOT}/NotContent`;

export const FilterWrapper = styled.span`
  font-family: ${FONTS.ROBOTO};
  font-size: 16px;
  display: flex;
  color: ${COLORS.GRAY_TEXT};
  span {
    display: none;
  }

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: block;
  }
`;

FilterWrapper.displayName = `${ROOT}/FilterWrapper`;

export const FilterItem = styled.li`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 17px;
  margin-left: 24px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 0;
  }
  & > a {
    color: ${COLORS.GRAY_TEXT};
  }

  ${(props: Props) => props.active && `
    & > a {
      color: #000;
    }

    &:after {
      content: '';
      position: absolute;
      width: 32px;
      border: 1px solid ${COLORS.BLUE_LINK};
      bottom: -6px;
      left: 50%;
      transform: translateX(-50%);
      transition: all .5s;
    }
  `}
`;

FilterItem.displayName = `${ROOT}/FilterItem`;

export const Separator = styled.hr`
  height: 16px;
  border-left: 1px solid #000;
  margin: 0 25px;
`;

Separator.displayName = `${ROOT}/Separator`;

export const Wrapper = styled.div`
  display: flex;
  margin-bottom: 32px;
  align-items: center;
`;

Wrapper.displayName = `${ROOT}/Wrapper`;

export const FilterList = styled.div`
  display: flex;
`;

FilterList.displayName = `${ROOT}/FilterList`;

export const TitleAvailable = styled.div`
  display: flex;
  align-items: center;
`;